import { render, staticRenderFns } from "./OwnerChip.vue?vue&type=template&id=9f9ceb94&scoped=true"
import script from "./OwnerChip.vue?vue&type=script&lang=js"
export * from "./OwnerChip.vue?vue&type=script&lang=js"
import style0 from "./OwnerChip.vue?vue&type=style&index=0&id=9f9ceb94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9ceb94",
  null
  
)

export default component.exports